const PreferredPronouns = ["He/Him/His", "She/Her/Hers", "They/Them/Theirs"];

export default PreferredPronouns;
